import React, { Component } from "react";
import Helmet from "../component/common/Helmet";
import ScrollspyTeste from 'react-scrollspy';
import ScrollSpy from "react-ui-scrollspy";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import FooterOne from "../component/footer/Footer";
import HubspotContactForm from '../elements/Hubspot';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';


const colorVert = <img src="assets/images/abm/bg-color-vert.svg" alt="Plugify" />
const bulletVert = <img src="assets/images/abm/bullets.svg" alt="Plugify" />
const bikeCol = <img src="assets/images/abm/persona-ABM-Plugify-Bike.webp" alt="Plugify" />




class ApplePage extends Component {
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

        window.addEventListener('load', function () {
            // console.log('All assets are loaded');
        })
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }
    stickyHeader() { }
    render() {
        window.addEventListener('scroll', function () {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            } else {
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });
        return (
            // <Fragment>
            <div className="active-dark">
                <Helmet pageTitle="Plugify" />
                {/* Start Header Area  */}
                <header className="header-area formobile-menu header--fixed default-color header-appleabm">
                    <div className="header-wrapper" id="header-wrapper">
                        <div className="header-left">
                            <div className="logo">
                                <Link to="../">
                                    <div data-to-scrollspy-id="home" className={"ss-item"}></div>
                                    <img className="logo-1" src="/assets/images/logo/logo-light.png" alt="Plugify" />
                                    <img className="logo-2" src="/assets/images/logo/logo-all-dark.png" alt="Plugify" />
                                </Link>

                            </div>
                        </div>
                        <div className="header-right">
                            <nav className="mainmenunav d-lg-block">

                                <ScrollspyTeste className="mainmenu" items={['home', 'apple reseller', ' ']} currentClassName="is-current" offset={-200}>
                                    <li><HashLink smooth to="../">Home</HashLink></li>

                                    <li><HashLink smooth to="../Apple">Apple Reseller</HashLink></li>

                                    <li className="line-apple-active">
                                        <p className="apple-active">Apple Business Manager</p>
                                    </li>
                                </ScrollspyTeste>
                            </nav>

                            <div className="header-btn">
                                <img className="logo-1" src="/assets/images/featured/appleReseller.png" alt="Apple Corporate Reseller" width={130} />
                            </div>
                            {/* Start Humberger Menu  */}
                            <div className="humberger-menu d-block d-lg-none pl--20">
                                <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                            </div>
                            {/* End Humberger Menu  */}
                            <div className="close-menu d-block d-lg-none">
                                <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                            </div>
                        </div>
                    </div>
                </header>
                {/* End Header Area  */}
                <ScrollSpy scrollThrottle={100} useBoxMethod={false} >
                    {/* Start Slider Area   */}
                    <div className="slide-abre" id=" " >
                        {/* Start Single Slide */}

                        <div className="slider-style-3 d-flex align-items-center justify-content-center bg_image--apple--abm">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <img className="imgAbreABM" src="/assets/images/abm/abertura_ABM-Plugify.webp" alt="Apple ABM Plugify" />
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* End Single Slide */}
                    </div>
                    {/* End Slider Area   */}

                    {/* Start Portfolio Area */}
                    <div className="sectionABM--default bg_color--appleabm " id="apple">
                        <div className="rn-slick-dot">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 sectionABM-01-container">
                                        <div className="imgColorVert">
                                            {colorVert}
                                        </div>
                                        <p className="text-abm col-lg-8">
                                            Os programas e serviços da Apple permitem que a equipe de TI implante e dê suporte aos sistemas iOS e macOS com facilidade. As soluções de gerenciamento de dispositivos desenvolvidas por terceiros, junto com os serviços oferecidos por nossos parceiros, dão às equipes de TI o controle e a simplicidade necessária.</p>
                                    </div>
                                    <div className="col-lg-4 col-sm-12 col-personas col-personas--1">
                                        <img className="personas personas--1" src="/assets/images/abm/persona-ABM-Plugify-01.webp" alt="Plugify" />
                                        <p className="text-abm txt-abm-p">Experiência focada no colaborador</p>
                                    </div>
                                    <div className="col-lg-4 col-sm-12 col-personas col-personas--2">
                                        <img className="personas personas--2" src="/assets/images/abm/persona-ABM-Plugify-02.webp" alt="Plugify" />
                                        <p className="text-abm txt-abm-p">Instalação e implementação inteligente</p>
                                    </div>
                                    <div className="col-lg-4 col-sm-12 col-personas col-personas--3">
                                        <img className="personas personas--3" src="/assets/images/abm/persona-ABM-Plugify-03.webp" alt="Plugify" />
                                        <p className="text-abm txt-abm-p">Controle supervisionados</p>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                    {/* End Portfolio Area */}

                    {/* Start About Area */}
                    <div className="sectionABM--default bg_image--apple--section3 " id="apple">
                      
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="col-lg-12 txt-abm-h3">
                                            Aumente a produtividade <br />de seus colaboradores com as <br /> experiências  sem interrupção
                                        </div>
                                        <div className="col-lg-12 sectionABM-01-container">
                                            <div>
                                                {bulletVert}
                                            </div>
                                            <p className="text-abm  text-abm-1 col-lg-10">
                                                <p className="txt-abm-h4">
                                                    Simples e intuitivo, potentes e seguro
                                                </p>
                                                Os produtos Apple irão levar a sua empresa mais a frente, com liberdade de escolha, agilidade na implementação no seu parque de TI e satisfação dos seus colaboradores, gerando maior retenção e fidelidade.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 imgBike">
                                        {bikeCol}
                                    </div>
                                </div>
                            </div>
            
                    </div>
                    {/* End About Area */}

                    {/* Start About Area */}
                    <div className="sectionABM--default bg_image--apple--section4" id="apple">
                       
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 sectionABM-01-container">
                                        <div className="text-abm img_text-abm col-lg-6">
                                            <img src="assets/images/abm/persona-ABM-Plugify-05.webp" alt="Plugify" />
                                        </div>
                                        <div className="text-abm-2 col-lg-6 col-sm-12">
                                            <p className="txt-abm-h3">
                                                Gerenciamento de dispositivos móveis (MDM) Apple
                                            </p>
                                            <p className="txt-abm-h4">
                                                A implantação sem intervenção humana direta
                                            </p>
                                            <p className="txt-abm-p">
                                                
                                            A implantação sem intervenção humana direta
                                            A equipe de TI pode configurar e gerenciar as políticas e aplicativos de forma remota com um controle ainda maior de cada dispositivo.
                                            As ferramentas nativas de segurança e as atualizaçõe de software mantêm os dados corporativos protegidos sem afetar a maneira em que os usuários preferem trabalhar. Os funcionários podem tirar seu dispositivo da embalagem, ligá-lo e personalizá-lo como quiserem, aumentando seu sentido propriedade e os tornando mais cuidadosos com o equipamento durante sua vida útil, através da estrutura de gerenciamento de dispositivos móveis (MDM) da Apple, ao Apple Device Enrollment Program (DEP) e às soluções MDM de terceiros.
                                            Dispositivo macOS ou iOS pode ser configurado automaticamente sem qualquer interação com o pessoal de TI, e pode ser facilmente administrado para cumprir os regulamentos da empresa, reduzindo os custos de TI e aumentando a produtividade.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    
                    </div>

                    {/* Start Contact Us */}
                    <div className="ptb--120 bg_color--form col-lg-12 bg_contato_plugify" id="contato">
                        <div className="container">
                            <div className="row container--form">
                                <div className="col-lg-7 bg_Form">
                                    <div className="section-title text-left mb--25 mb_sm--0">
                                        <h2 className="titleProdApple" style={{ color: '#000' }}> Preencha o formulário para entrarmos em contato.</h2>
                                    </div>
                                    <HubspotProvider>
                                        <HubspotContactForm />
                                    </HubspotProvider>
                                </div>
                            </div>
                            {/* <Contact /> */}
                        </div>
                    </div>
                    {/* End Contact Us */}
                </ScrollSpy>

                {/* Start Footer Style  */}
                <FooterOne />
                {/* End Footer Style  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop
                        showUnder={160}
                        easing='easeInQuad'
                        duration={700}
                    >
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

            </div>
            // </Fragment>

        )
    }
}
export default ApplePage;  